import { createContext } from "react";

export const TenderTimeContext = createContext(null);
